export default __webpack_public_path__ + "static/SCROLL_7-d05c49946102aed1a0ab191cd830e088.png";